import { MarketApiResponse } from "src/model/shop.model";
import { AppState } from "..";
import { StateUpdaterMap } from "src/model/manager/state-manager";
import { getLegalContent, getRestrictedAddressCodes, getShopId } from "src/utils/init/configuration";

export interface StoreActions {
    STORE_SET_CONFIG: MarketApiResponse;
}

export const storeActions: StateUpdaterMap<AppState, StoreActions> = {
    STORE_SET_CONFIG: (storeData, _) => ({
        store: {
            storeId: getShopId(storeData),
            restrictedAddressCodes: getRestrictedAddressCodes(storeData),
            legalContent: getLegalContent(storeData)
        }
    })
}